import React from 'react'
import MenuItem from 'material-ui/MenuItem'
import config from '../../config'

const buildMenuItems = (resource, showDeprecatedFieldsOption) => {
  const menuItems = [
    <MenuItem
      primaryText='Summary'
      key='summary'
      value={`/events/session-sales/${resource.id}/summary`}
    />,
    showDeprecatedFieldsOption ? (
      <MenuItem
        primaryText='Edit Depcreated Fields'
        key='edit'
        value={`/events/session-sales/${resource.id}/edit?showDeprecatedFields=true`}
      />
    ) : (
      <MenuItem
        primaryText='Edit'
        key='edit'
        value={`/events/session-sales/${resource.id}/edit`}
      />
    ),
    <MenuItem
      primaryText='Reservations'
      key='reservations'
      value={`/events/session-sales/${resource.id}/reservations`}
    />,
    <MenuItem
      primaryText='Waitlist'
      key='waitlist'
      value={`/events/session-sales/${resource.id}/waitlist`}
    />,
    <MenuItem
      primaryText='Intake Questions'
      key='intake-questions'
      value={`/events/session-sales/${resource.id}/intake-questions`}
    />,
    <MenuItem
      primaryText='Orders'
      key='orders'
      value={`/ecommerce/orders?filters[session_sale_id]=${resource.id}`}
    />,
    <MenuItem key='view'>
      <a
        style={{ color: 'inherit', textDecoration: 'none' }}
        href={`${config.webUrl}sessions/${resource.slug}`}
        target='_blank' rel="noreferrer"
      >
        View
      </a>
    </MenuItem>
  ]

  return menuItems
}

export default buildMenuItems
